class SignUpController extends BaseController
	@register angular.module 'App.Module.Controller'
	@inject '$rootScope',
		'$filter'
		'PublicRepository'
		'ToastService'
		'countries'
		'TERMS_URL'

	initialize: ->
		@signUpData =
			is_base_license: '1'
			country_code: @countries[0].iso
			accepted_terms: false

	hasMultipleLicenses: ->
		country = _.find @countries, {iso: @signUpData.country_code}

		return country.licenses?.length != 1

	signUp: ->
		if !@hasMultipleLicenses()
			@signUpData.is_base_license = '1'

		@PublicRepository
			.signUp @signUpData
			.then (response) =>
				@ToastService.add(
						response.data.email,
						@$filter('translate')('general.sign.up'),
						@$filter('translate')('general.success'),
						'success'
					)
				@$rootScope.$broadcast 'registration'
			.catch (response) =>
				@ToastService.showErrors response.data, @$filter('translate')('general.sign.up')
